export default __webpack_public_path__ + "static/media/EliasIbnoussima.5b470bd3.webp";